import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest} from "@api/ApiService";
import {API_MODULES, API_ROUTES, API_SOLUTIONS} from "@api/ApiRoutes";
import {PointsCapCheckResponse} from "@lib/PointsCap/PointsCapModels";

const ROUTE = {
    path: API_ROUTES.POINTSCAP_CHECK_USER,
    module: API_MODULES.EXT,
    solution: API_SOLUTIONS.MZ,
};

class PointsCapService {

    static checkUserCap = async (): Promise<PointsCapCheckResponse> => {
        const url = generateApiEndpoint(ROUTE);

        return getRequest<PointsCapCheckResponse>(url);
    };

}

export default PointsCapService;
